import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
// import Logo from "../../assets/images/happyfarmlogo.png";
import Logo from "../../assets/images/sabba krish.png";
import Button from "@mui/material/Button";
import CountryDropdown from "../CountryDropdown";
import { FiUser } from "react-icons/fi";
import { IoBagOutline } from "react-icons/io5";
import SearchBox from "./SearchBox";
import Navigation from "./Navigation";
import { useContext } from "react";
import { MyContext } from "../../App";
import { FaRegHeart } from "react-icons/fa";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import { FaHeart } from "react-icons/fa";
import { RiLogoutCircleRFill } from "react-icons/ri";
import { FaUserAlt } from "react-icons/fa";
import { IoMdMenu } from "react-icons/io";
import { IoIosSearch } from "react-icons/io";
import { FaAngleLeft } from "react-icons/fa6";
import { FaAngleUp } from "react-icons/fa6";
import UserAvatarImgComponent from "../userAvatarImg";
import { IoHomeOutline } from "react-icons/io5";
import { IoMdHeartEmpty } from "react-icons/io";
import { FaRegUser } from "react-icons/fa6";
import { CiFilter } from "react-icons/ci";
import { IoBagCheckOutline } from "react-icons/io5";
import { setAuthenticated, setJwtToken } from "../../store/slices/AuthSlice";
import { clearCart } from "../../store/slices/CartSlice";
import { clearWishlist } from "../../store/slices/WishlistSlice";
import { clearOrders } from "../../store/slices/OrdersSlice";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import "./header.css";

const Header = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [isOpenNav, setIsOpenNav] = useState(false);
  const [isOpenSearch, setIsOpenSearch] = useState(false);
  const open = Boolean(anchorEl);

  const headerRef = useRef();
  const gotoTop = useRef();
  const context = useContext(MyContext);
  const dispatch = useDispatch();
  const cartItems = useSelector((state) => state.cart.cartItems);
  const total = useSelector((state) => state.cart.total);

  const history = useNavigate();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const logout = () => {
    setAnchorEl(null);
    // Clear all localStorage data
    localStorage.clear();
    // Clear Redux state
    dispatch(setAuthenticated(false));
    dispatch(setJwtToken(null));
    dispatch(clearCart());
    dispatch(clearWishlist());
    dispatch(clearOrders());
    // Reset context state
    context.setIsLogin(false);
    context.setUser(null);
    context.setCartData(null);
    // Redirect to login page
    history("/");
  };

  useEffect(() => {
    window.addEventListener("scroll", () => {
      let position = window.pageYOffset;
      if (headerRef.current) {
        if (position > 100) {
          headerRef.current.classList.add("fixed");
        } else {
          headerRef.current.classList.remove("fixed");
        }
      }

      if (gotoTop.current) {
        if (position > 500) {
          gotoTop.current.classList.add("show");
        } else {
          gotoTop.current.classList.remove("show");
        }
      }
    });
  }, []);

  const openNav = () => {
    setIsOpenNav(!isOpenNav);
    context.setIsOpenNav(true);
    context.setIsBottomShow(false);
  };

  const closeNav = () => {
    setIsOpenNav(false);
    context.setIsOpenNav(false);
    context.setIsBottomShow(true);
  };

  const openSearch = () => {
    setIsOpenSearch(!isOpenSearch);
  };

  const closeSearch = () => {
    setIsOpenSearch(false);
  };

  const gotoTopScroll = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const openFilter = () => {
    context?.setIsOpenFilters(!context?.isOpenFilters);
  };

  return (
    <>
      <Button className="gotoTop" ref={gotoTop} onClick={gotoTopScroll}>
        <FaAngleUp />
      </Button>

      <div className="headerWrapperFixed" ref={headerRef}>
        <div className="headerWrapper">
          <div className="top-strip bg-blue">
            <div className="container">
              <ul className="nav-list">
                <li className="nav-item">sell on SabbaFarm</li>
                <li className="nav-item">Bulk order inquiries</li>
                <li className="nav-item">corporate site</li>
                <li className="nav-item mob">
                  Missed call to Order:9866113858
                </li>
              </ul>
            </div>
          </div>

          <header className="header">
            <div className="container">
              <div className="row">
                <div className="logoWrapper d-flex align-items-center col-sm-2">
                  {context.windowWidth < 992 && (
                    <Button className="circle toggleNav" onClick={openNav}>
                      <IoMdMenu />
                    </Button>
                  )}

                  <Link to={"/"} className="logo">
                    <img src={Logo} alt="Logo" />
                  </Link>
                  {context.windowWidth < 992 && (
                    <div className="position-relative cartTab">
                      <Link to="/cart" className="ml-auto">
                        <Button className="circle">
                          {/* <IoBagOutline /> */}
                          <div className="mix-blend-multiply">
                            <img src="/cart.gif" alt="" />
                          </div>
                        </Button>

                        {/* <span className="count d-flex align-items-center justify-content-center">
                          {context.cartData?.data?.length > 0
                            ? context.cartData?.data?.length
                            : 0}
                        </span> */}
                      </Link>
                    </div>
                  )}
                </div>

                <div className="col-sm-10 d-flex align-items-center part2">
                  <div
                    className={`headerSearchWrapper ${
                      isOpenSearch === true && "open"
                    }`}
                  >
                    <div className=" d-flex align-items-center">
                      <SearchBox closeSearch={closeSearch} />
                    </div>
                  </div>
                  <div className=" items-center hidden md:flex">
                    <div className="hidden sm:block ml-auto mt-[-4px]  me-[-20px] group ">
                      <Link to="/my-list">
                        <MenuItem
                          onClick={handleClose}
                          className="left-9 hover:text-green-500 transition-colors duration-300"
                        >
                          <ListItemIcon className="mr-[-12px] group-hover:text-green-500">
                            <FaRegHeart
                              fontSize="small"
                              className="group-hover:text-green-500"
                              size={18}
                            />
                          </ListItemIcon>
                          <span className="text-[14px] group-hover:text-green-500">
                            WishList
                          </span>
                        </MenuItem>
                      </Link>
                    </div>

                    <div className="hidden sm:block mx-2 mt-[-4px] pe-3 group ">
                      <Link to="/orders">
                        <MenuItem
                          onClick={handleClose}
                          className="left-9 hover:text-green-500 transition-colors duration-300"
                        >
                          <ListItemIcon className="mr-[-12px] group-hover:text-green-500">
                            <IoBagCheckOutline
                              fontSize="small"
                              className="group-hover:text-green-500"
                              size={18}
                            />
                          </ListItemIcon>
                          <span className="text-[14px] group-hover:text-green-500">
                            Orders
                          </span>
                        </MenuItem>
                      </Link>
                    </div>
                    <div className=" d-flex align-items-center ms-5">
                      <h5 className="mb-1 mt-0 me-2 text-nowrap font-semibold">
                        {context?.user?.name?.slice(0, 20)}
                      </h5>
                      {context.isLogin !== true &&
                        context.windowWidth > 992 && (
                          <Link to="/signIn">
                            <Button className="btn-blue btn-round mr-3 whitespace-nowrap">
                              Sign In
                            </Button>
                          </Link>
                        )}

                      {context.isLogin === true && (
                        <div className="res-hide">
                          <Button className="circle mr-3" onClick={handleClick}>
                            {/* <FiUser /> */}
                            <div className="img">
                              <UserAvatarImgComponent
                                img={context?.user?.image}
                                userName={context?.user?.name?.toUpperCase()}
                              />
                            </div>
                          </Button>
                          <Menu
                            anchorEl={anchorEl}
                            id="accDrop"
                            open={open}
                            onClose={handleClose}
                            onClick={handleClose}
                            transformOrigin={{
                              horizontal: "right",
                              vertical: "top",
                            }}
                            anchorOrigin={{
                              horizontal: "right",
                              vertical: "bottom",
                            }}
                          >
                            <div className="info d-flex align-items-center">
                              <div className="img">
                                <UserAvatarImgComponent
                                  img={context?.user?.image}
                                  userName={context?.user?.name?.toUpperCase()}
                                />
                              </div>

                              <div className="ml-3">
                                <h5 className="mb-1 mt-0">
                                  {context?.user?.name}
                                </h5>
                                <h6 className="text-sml text-light">
                                  {context?.user?.email}
                                </h6>
                              </div>
                            </div>

                            <Link to="/my-account">
                              <MenuItem onClick={handleClose}>
                                <ListItemIcon>
                                  <FaUserAlt fontSize="small" />
                                </ListItemIcon>
                                My Account
                              </MenuItem>
                            </Link>
                            <MenuItem onClick={logout}>
                              <ListItemIcon>
                                <RiLogoutCircleRFill fontSize="small" />
                              </ListItemIcon>
                              Logout
                            </MenuItem>
                          </Menu>
                        </div>
                      )}

                      <div className="ml-auto cartTab d-flex align-items-center">
                        {context.windowWidth > 1000 && (
                          <span className="price">
                            {total?.toLocaleString("en-IN", {
                              style: "currency",
                              currency: "INR",
                              maximumFractionDigits: 0,
                            })}
                          </span>
                        )}

                        <div className="position-relative ml-2 res-hide">
                          <Link to="/cart">
                            <Button className="circle">
                              {/* <IoBagOutline /> */}
                              <div className="mix-blend-multiply ">
                                <img
                                  src="/cart.gif"
                                  alt=""
                                  className="h-6 w-6"
                                />
                              </div>
                            </Button>
                            {/* <span className="count d-flex align-items-center justify-content-center">
                      

                            {context.cartData?.data?.length > 0
                              ? context.cartData?.data?.length
                              : 0}
                          </span> */}
                          </Link>
                        </div>

                        {context.windowWidth < 992 && (
                          <Button
                            className="circle ml-3 toggleNav res-hide"
                            onClick={openNav}
                          >
                            <IoMdMenu />
                          </Button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </header>

          {context.categoryData?.length !== 0 && (
            <Navigation
              navData={context.categoryData}
              isOpenNav={isOpenNav}
              closeNav={closeNav}
            />
          )}
        </div>

        {context.windowWidth < 992 && context?.isBottomShow === true && (
          <div className="fixed-bottom-menu d-flex align-self-center justify-content-between">
            <Link to="/" onClick={() => setIsOpenSearch(false)}>
              <Button className="circle hover:text-green-500 transition-colors duration-300">
                <div className="d-flex align-items-center justify-content-center flex-column">
                  <IoHomeOutline />
                  <span className="title">Home</span>
                </div>
              </Button>
            </Link>

            {context.enableFilterTab === true && (
              <Button
                className="circle hover:text-green-500 transition-colors duration-300"
                onClick={() => {
                  openFilter();
                  setIsOpenSearch(false);
                }}
              >
                <div className="d-flex align-items-center justify-content-center flex-column">
                  <CiFilter />
                  <span className="title">Filters</span>
                </div>
              </Button>
            )}

            <Button
              className="circle hover:text-green-500 transition-colors duration-300"
              onClick={openSearch}
            >
              <div className="d-flex align-items-center justify-content-center flex-column">
                <IoIosSearch />
                <span className="title">Search</span>
              </div>
            </Button>

            <Link to="/my-list" onClick={() => setIsOpenSearch(false)}>
              <Button className="circle hover:text-green-500 transition-colors duration-300">
                <div className="d-flex align-items-center justify-content-center flex-column">
                  <FaRegHeart />
                  <span className="title">Wishlist</span>
                </div>
              </Button>
            </Link>

            <Link to="/orders" onClick={() => setIsOpenSearch(false)}>
              <Button className="circle hover:text-green-500 transition-colors duration-300">
                <div className="d-flex align-items-center justify-content-center flex-column">
                  <IoBagCheckOutline />
                  <span className="title">Orders</span>
                </div>
              </Button>
            </Link>

            <Link to="/my-account" onClick={() => setIsOpenSearch(false)}>
              <Button className="circle hover:text-green-500 transition-colors duration-300">
                <div className="d-flex align-items-center justify-content-center flex-column">
                  <FaRegUser />
                  <span className="title">Account</span>
                </div>
              </Button>
            </Link>
          </div>
        )}
      </div>
    </>
  );
};

export default Header;
